import { render, staticRenderFns } from "./ConfigBackupTableButton.vue?vue&type=template&id=3b32ed62&scoped=true&"
import script from "./ConfigBackupTableButton.vue?vue&type=script&lang=js&"
export * from "./ConfigBackupTableButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b32ed62",
  null
  
)

export default component.exports